
import { AuthenticationService } from '../../services/authentication.service';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
 
@Component({
    moduleId: module.id,
    templateUrl: './login.component.html',
    selector: 'app-login',
    styleUrls: ['./login.component.css']
})
 
export class LoginComponent implements OnInit {
    model: any = {};
    loading = false;
    returnUrl: string;
    userIsLoggedIn: boolean = false;
    success_message: any = null;
    error_message: any = null;
 
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService
    ) { }
 
    ngOnInit() {
        // reset login status
        this.authenticationService.logout();
 
        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/dashboard';
    }
 
    login() {
        this.authenticationService.login(this.model.username, this.model.password)
            .subscribe(
                data => {
                    this.success_message = "Logged In success"
                    this.router.navigate([this.returnUrl]);
                },
                error => {
                  
                  this.error_message = JSON.parse(error._body).non_field_errors
                   
                    this.loading = false;
                });
    }
}


// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts